const urlCreate = `/api/app/create-donate?api_key=${TheApp.CurrentContext.app.jsApiKey}`;
const urlSub = `/api/app/create-subscription?api_key=${TheApp.CurrentContext.app.jsApiKey}`;

let currentPlanId = null;
let currentDonateUid = null;

export default function paypalSubscription({
    elem,
    data,
    onSuccess = null,
    onCancel = null,
    onError = null,
    onCreateError = null,
    setLoading = null
}) {
    let errorTriggered = false;

    return window.paypal.Buttons({
        createSubscription: async (_data, actions) => {
            try {
                const response = await fetch(urlCreate, {
                    method: 'post',
                    headers: { 'content-type': 'application/json' },
                    body: JSON.stringify({
                        "ContentLocale": TheApp.ContentLocale,
                        "Data": data
                    })
                });

                const result = await response.json();
                const planId = result.PlanId;
                const donateUid = result.DonateUid;

                currentPlanId = result.PlanId;
                currentDonateUid = result.DonateUid;

                //console.log("log", currentDonateUid);

                if (result?.Errors?.length > 0) {
                    const { Errors } = result;
                    onCreateError?.({ Errors });
                    errorTriggered = true;
                }

                if (!planId || !donateUid) {                    
                    throw new Error('Errore nella creazione del piano: ' + planId);
                }

                // Ora crea la sottoscrizione con il plan_id generato
                return actions.subscription.create({
                    'plan_id': planId,
                    'custom_id': donateUid
                });

            } catch (err) {
                console.log(err);                
            }            
        },
        onApprove: async (data, actions) => {
            setLoading?.(true);
            const rq = { OrderId: data.orderID };

            try {
                const updateData = {
                    PlanId: currentPlanId, // UID del record creato prima
                    SubscriptionId: data.subscriptionID,
                    OrderId: data.orderID,
                    DonateUid: currentDonateUid
                };

                const response = await fetch(urlSub, {
                    method: 'post',
                    headers: { 'content-type': 'application/json' },
                    body: JSON.stringify(updateData)
                });

                const result = await response.json();

            } catch (error) {
                console.error('Errore:', error);
                setLoading?.(false);
                if (!errorTriggered)
                    onError?.();
            }

            setLoading?.(false);
            onSuccess?.();
        },
        onCancel: (data) => {
            onCancel?.();
        },
        onError: (err) => {
            console.log("onError", err);
            if (!errorTriggered)
                onError?.();
        }
    }).render(elem);
}